import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppMode } from "@/shared/hooks/useAppMode";
import { getTargetRoute } from "@/shared/utils/helperFunctions";

// Pill toggle for org admins
export default function ModeToggle() {
  const navigate = useNavigate();
  const { user, appMode, isOrgAdmin, setAppMode } = useAppMode();
  const [overlayMessage, setOverlayMessage] = useState(null);

  const switchMode = useCallback(
    (next) => {
      if (appMode === next || !user?.id) return;
      setOverlayMessage(
        next === "user"
          ? "Switching to User Mode..."
          : "Switching to Admin Mode...",
      );
      setAppMode(next);
      navigate(getTargetRoute(user, { appMode: next }), { replace: true });
      window.setTimeout(() => setOverlayMessage(null), 800);
    },
    [appMode, user, setAppMode, navigate],
  );

  if (!isOrgAdmin) return null;

  return (
    <>
      {overlayMessage ? (
        <div
          className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/35 mode-switch-overlay pointer-events-none"
          aria-live="polite"
          role="status"
        >
          <div className="pointer-events-none rounded-xl bg-white dark:bg-gray-900 px-8 py-5 shadow-lg border border-gray-100 dark:border-gray-800 text-sm font-semibold text-gray-800 dark:text-gray-100">
            {overlayMessage}
          </div>
        </div>
      ) : null}

      <div
        className="flex w-full flex-col gap-1"
        role="group"
        aria-label="Application mode"
      >
        <span className="text-[10px] uppercase tracking-wide text-gray-800 dark:text-gray-400 font-semibold px-0.5">
          View as
        </span>
        <div className="flex rounded-lg border border-gray-200 dark:border-gray-800 bg-gray-50/80 dark:bg-gray-800/80 p-0.5 shadow-xs">
          <button
            type="button"
            onClick={() => switchMode("admin")}
            className={`flex-1 rounded-md px-1.5 py-1.5 text-[11px] font-semibold transition-all ${appMode === "admin"
              ? "bg-secondary text-white shadow-xs"
              : "text-gray-600 dark:text-gray-300 hover:bg-white/80 dark:hover:bg-gray-700/80"
              }`}
          >
            Admin
          </button>
          <button
            type="button"
            onClick={() => switchMode("user")}
            className={`flex-1 rounded-md px-2 py-1.5 text-[11px] font-semibold transition-all ${appMode === "user"
              ? "bg-secondary text-white shadow-xs"
              : "text-gray-600 dark:text-gray-300 hover:bg-white/80 dark:hover:bg-gray-700/80"
              }`}
          >
            User
          </button>
        </div>
      </div>
    </>
  );
}
